import { FnAxiosInstance } from 'src/shared/services/axios';

type QueryParams = {
  [key: string]: string | number | boolean | undefined;
};

type ValidQueryParams = Record<string, string | number | boolean>;

const filterParams = (params?: QueryParams): ValidQueryParams | undefined => {
  if (!params) return undefined;

  const filteredParams: ValidQueryParams = {};

  for (const key in params) {
    const value = params[key];
    if (value != undefined) {
      filteredParams[key] = value;
    }
  }

  return Object.keys(filteredParams).length > 0 ? filteredParams : undefined;
};

export const createApiFetcher = (baseUrl: string) => {
  return async <T>(endpoint: string, params?: QueryParams): Promise<T> => {
    const filteredParams = filterParams(params);
    const response = await FnAxiosInstance.get<T>(`${baseUrl}${endpoint}`, { params: filteredParams });
    return response.data;
  };
};

export const createApiPoster = (baseUrl: string) => {
  return async <T, D = any>(endpoint: string, data?: D, params?: QueryParams): Promise<T> => {
    const filteredParams = filterParams(params);
    const response = await FnAxiosInstance.post<T>(`${baseUrl}${endpoint}`, data, { params: filteredParams });
    return response.data;
  };
};

export const createApiUpdater = (baseUrl: string) => {
  return async <T, D = any>(endpoint: string, data?: D, params?: QueryParams): Promise<T> => {
    const filteredParams = filterParams(params);
    const response = await FnAxiosInstance.put<T>(`${baseUrl}${endpoint}`, data, { params: filteredParams });
    return response.data;
  };
};

export const createApiDeleter = (baseUrl: string) => {
  return async <T>(endpoint: string): Promise<T> => {
    const response = await FnAxiosInstance.delete<T>(`${baseUrl}${endpoint}`);
    return response.data;
  };
};

export const uploadFile = async <T>(
  endpoint: string,
  formData: FormData,
  axiosInstance = FnAxiosInstance
): Promise<T> => {
  const response = await axiosInstance.post(endpoint, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
